import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { ProjectsService } from '@app/features/main/views/projects/projects.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'projects-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class ProjectsIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private projectsService = inject(ProjectsService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.projectsService.projectAdded$,
      this.projectsService.projectUpdated$,
      this.projectsService.projectsDeleted$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.projectsService.loadProjectsPage(selectParams)
      .pipe(first(), map(projects => projects.first()));
  }
}
